{
  "translation": {
    "aboutMirador": "За проекта Mirador",
    "aboutThisItem": "За този елемент",
    "addedFromUrl": "(Добавено от линк)",
    "addManifestUrl": "Адрес на ресурса",
    "addManifestUrlHelp": "Адресът на IIIF ресурса",
    "addResource": "Добавяне на ресурс",
    "annotationCanvasLabel_1/1": "Елемент: [{{label}}]",
    "annotationCanvasLabel_1/2": "Ляво: [{{label}}]",
    "annotationCanvasLabel_2/2": "Дясно: [{{label}}]",
    "annotations": "Анотации",
    "attribution": "Принос",
    "attributionTitle": "Права",
    "authenticationFailed": "Неуспешна аутентикация.",
    "authenticationRequired": "Необходима е аутентикация за пълен достъп",
    "backToResults": "Назад към ресултатите",
    "book": "Книга",
    "bottom": "Долу",
    "cancel": "Отказ",
    "canvasIndex": "Индекс",
    "changeTheme": "Промяна на темата",
    "clearSearch": "изчистване",
    "close": "Затвори",
    "closeAddResourceForm": "Затваряне на формата",
    "closeAddResourceMenu": "Затваряне на списъка с ресурси",
    "closeCompanionWindow": "Затваряне на панела",
    "closeWindow": "Затваряне на прозореца",
    "collapseSection": "Свиване на секция \"{{section}}\"",
    "collapseSidePanel": "Свиване на страничен панел",
    "collection": "Колекция",
    "continue": "Продължи",
    "copy": "Копиране",
    "currentItem": "Текущ елемент",
    "currentItem_1/1": "Текущ елемент",
    "currentItem_1/2": "Ляво",
    "currentItem_2/2": "Дясно",
    "dark": "Тъмен режим",
    "digitizedView": "Цифровизиран преглед",
    "dismiss": "Отхвърляне",
    "displayNoAnnotations": "Изчистване на маркирането",
    "downloadExport": "Експорт на работното пространство",
    "downloadExportWorkspace": "Експорт на работното пространство",
    "elastic": "Еластичен",
    "elasticDescription": "Премествайте и оразмерявайте прозорците свободно в неограничено работно пространство. Прозорците могат да се застъпват.",
    "emptyResourceList": "Списъкът с ресурси е празен",
    "error": "Грешка",
    "errorDialogConfirm": "OK",
    "errorDialogTitle": "Възникна грешка",
    "exitFullScreen": "Изход от цял екран",
    "expandSection": "Разширяване на секция \"{{section}}\"",
    "expandSidePanel": "разширяване на страничния панел",
    "exportCopied": "Конфигурацията на работното пространство е копирана в клипборда",
    "fetchManifest": "Добавяне",
    "fullScreen": "Цял екран",
    "gallery": "Галерия",
    "hideZoomControls": "Скриване на контролите за мащабиране",
    "highlightAllAnnotations": "Маркиране на всичко",
    "iiif_homepage": "За този ресурс",
    "iiif_manifest": "IIIF манифест",
    "iiif_related": "Свързано",
    "iiif_renderings": "Алтернативни формати",
    "iiif_seeAlso": "Вижте също",
    "import": "Импорт",
    "importWorkspace": "Импорт на работно пространство",
    "importWorkspaceHint": "Поставете Mirador 4 конфигурация за импорт",
    "item": "Елемент: {{label}}",
    "itemList": "Списък с елементи",
    "jsError": "Технически детайли",
    "jsStack": "{{ stack }}",
    "language": "Език",
    "layer_hide": "Скриване на слой",
    "layer_move": "Преместване на слой",
    "layer_opacity": "Прозрачност на слой",
    "layer_show": "Показване на слой",
    "layers": "Слоеве",
    "light": "Светъл режим",
    "links": "Връзки",
    "listAllOpenWindows": "Към прозорец",
    "login": "Вход",
    "logout": "Изход",
    "manifestError": "Ресурсът не може да бъде добавен:",
    "maximizeWindow": "Увеличаване на прозореца",
    "minimizeWindow": "Минимизиране на прозореца",
    "mirador": "Mirador",
    "miradorResources": "Mirador ресурси",
    "miradorViewer": "Mirador viewer",
    "more": "още...",
    "moreResults": "Още резултати",
    "mosaic": "Мозайка",
    "mosaicDescription": "Премествайте и оразмерявайте прозорците помежду им в рамките на видимата рамка.",
    "moveCompanionWindowToBottom": "Преместване отдолу",
    "moveCompanionWindowToRight": "Преместване вдясно",
    "multipartCollection": "Колекция от много части",
    "nextCanvas": "Следващ елемент",
    "noItemSelected": "Не е избран елемент",
    "numItems": "{{number}} елемент",
    "numItems_plural": "{{number}} елемента",
    "off": "Изключено",
    "openCompanionWindow_annotations": "Анотации",
    "openCompanionWindow_attribution": "Права",
    "openCompanionWindow_canvas": "Индекс",
    "openCompanionWindow_info": "Информация",
    "openCompanionWindow_layers": "Слоеве",
    "openCompanionWindow_search": "Търсене",
    "openInCompanionWindow": "Отваряне в отделен панел",
    "openWindows": "Текущо отворени прозорци",
    "pagination": "{{current}} от {{total}}",
    "position": "Позиция",
    "previewWindowTitle": "{{title}}",
    "previousCanvas": "Предишен елемент",
    "related": "Свързано",
    "resource": "Ресурс",
    "retry": "Опитайте отново",
    "right": "Дясно",
    "rights": "Лиценз",
    "scroll": "Скрол",
    "searchInputLabel": "термини за търсене",
    "searchNextResult": "Следващ резултат",
    "searchNoResults": "Не са намерени резултати",
    "searchPreviousResult": "Предишен резултат",
    "searchResultsRemaining": "{{numLeft}} оставащи",
    "searchSubmitAria": "Търси",
    "searchTitle": "Търсене",
    "selectWorkspaceMenu": "Посочете тип работно пространство",
    "showCollection": "Показване на колекция",
    "showingNumAnnotations": "Показване на {{number}} анотация",
    "showingNumAnnotations_plural": "Показване на {{number}} анотации",
    "showZoomControls": "Показване на контролите за мащабиране",
    "sidebarPanelsNavigation": "Навигация на страничните панели",
    "single": "Единичен",
    "startHere": "Започнете оттук",
    "suggestSearch": "Търсене в този документ за \"{{ query }}\"",
    "tableOfContentsList": "Съдържание",
    "theme": "Тема",
    "thumbnailList": "Списък с представителни изображения",
    "thumbnailNavigation": "Представителни изображения",
    "thumbnails": "Представителни изображения",
    "toggleWindowSideBar": "Превключване на страничния панел",
    "totalCollections": "{{count}} колекция",
    "totalCollections_plural": "{{count}} колекции",
    "totalManifests": "{{count}} манифест",
    "totalManifests_plural": "{{count}} манифеста",
    "tryAgain": "Опитайте отново",
    "untitled": "[Неозаглавено]",
    "view": "Изглед",
    "viewWorkspaceConfiguration": "Преглед на конфигурацията на работното пространство",
    "welcome": "Добре дошли в Mirador",
    "window": "Прозорец: {{label}}",
    "windowMenu": "Изгледи на прозорците и на елементите",
    "windowNavigation": "Навигация на прозорците",
    "windowPluginButtons": "Настройки",
    "windowPluginMenu": "Настройки на прозорците",
    "workspace": "Работно пространство",
    "workspaceFullScreen": "Цял екран",
    "workspaceMenu": "Настройки на работното пространство",
    "workspaceNavigation": "Навигация на работното пространство",
    "workspaceOptions": "Опции за работното пространство",
    "workspaceSelectionTitle": "Изберете тип на работно пространство",
    "zoomIn": "Увеличаване",
    "zoomOut": "Намаляване",
    "zoomReset": "Нулиране"
  }
}
